module.exports = __webpack_public_path__ + "static/img/logo-project2.dad54bd0.png";